import styled, { createGlobalStyle } from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  height: 100%;
  z-index: 10;
  display: ${({ isModalHidden }) => (isModalHidden ? 'none' : 'flex')};
  background: rgba(${({ theme }) => theme.colors.rgb.black50PercentOpacity});
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 52;
  display: ${({ isModalHidden }) => (isModalHidden ? 'none' : 'flex')};

  ${({ extendStyle }) => extendStyle || ''};
`;

export const ModalContent = styled.div`
  border-radius: 20px;
  width: 407px;
  box-shadow: 0 5px 15px rgba(${({ theme }) => theme.colors.rgb.black50PercentOpacity});
  background-color: ${({ theme }) => theme.colors.white};

  ${({ extendStyle }) => extendStyle || ''};
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0 16px;

  ${({ extendStyle }) => extendStyle || ''};
`;

export const CloseButton = styled.button`
  margin-inline-start: auto;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  &::after {
    content: ${'"\\e91f"'};
    font-family: 'icomoon' !important;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey600};
  }
`;

export const ModalBody = styled.div`
  padding: 0 32px 32px 32px;

  ${({ extendStyle }) => extendStyle || ''};
`;

export const PreventBodyScrolling = createGlobalStyle`
  body {
    ${({ isModalHidden }) => !isModalHidden && 'overflow: hidden;'}
  }
`;
